import Vue from 'vue';

Vue.prototype.$messageWrapper = option => Vue.prototype.$message({ showClose: true, ...option });
Vue.prototype.$messageWrapper.success = mes => Vue.prototype.$message.success({ showClose: true, message: mes });
Vue.prototype.$messageWrapper.warning = mes => Vue.prototype.$message.warning({ showClose: true, message: mes });
Vue.prototype.$messageWrapper.error = mes => Vue.prototype.$message.error({ showClose: true, message: mes });
Vue.prototype.$messageWrapper.info = mes => Vue.prototype.$message.info({ showClose: true, message: mes });